const {
  GeoFirestore
} = require('geofirestore');

const {
  FirestoreModel,
  runQuery
} = require('./FirestoreModel');
/**
 * Wraps the FirestoreModel to add support for Geoqueries
 */


class GeoFirestoreModel extends FirestoreModel {
  /**
   * Main constructor
   * @param firestore     Initialized instance of Firestore
   * @param functions     Initialized instance of Firebase Functions
   * @param collection    The name of the Firestore collection for this model
   * @param schema        The Yup schema of this model
   * @param queries       The object containing methods for special queries of this model's collection
   * @param callables     The object containing methods for calling https-callable Cloud Function
   * @param mixins        The object containing helper-like methods to attach to each converted model from this schema
   * @param convertDates  The function for converting Timestamp objects to JS Dates whenever models are inflated from Firestore
   */
  constructor(firestore, functions, collection, schema, queries, callables, mixins, convertDates) {
    super(firestore, functions, collection, schema, queries, callables, mixins, convertDates);
    this.geoFirestore = new GeoFirestore(firestore);
    this.GeoPoint = firestore.GeoPoint;
  }
  /**
   * Performs a Geoquery for entities
   * @param lat   Latitude of the centerpoint
   * @param lng   Longitude of the centerpoint
   * @param radiusInMeters    Distance from the centerpoint to include results
   * @returns {Promise<*>}
   */


  search(lat, lng, radiusInMeters) {
    const radiusInKms = radiusInMeters / 1000.0;
    const query = this.geoFirestore.collection(this.collection).near({
      center: new this.GeoPoint(lat, lng),
      radius: radiusInKms
    });
    return runQuery(query, this.convertDates, this.mixins);
  }
  /**
   * Saves the supplied object using GeoFirestore
   * @param object    Record to save
   * @param lat   Latitude of the record
   * @param lng   Longitude of the record
   * @returns {Promise<GeoDocumentReference|void>}
   */


  async save(object, lat, lng) {
    const validatedObject = await this.validate(object);
    const objectWithCoordinates = { ...validatedObject,
      coordinates: new this.GeoPoint(lat, lng)
    };

    if (object.id) {
      return this.geoFirestore.collection(this.collection).doc(object.id).set(objectWithCoordinates);
    }

    return this.geoFirestore.collection(this.collection).add(objectWithCoordinates);
  }

}

module.exports = {
  GeoFirestoreModel
};